import { Theme } from '@mui/material/styles'
import { supportChatInset } from '@tm/ui/atomic/SupportChat/supportChatInset'

export default function Snackbar(theme: Theme) {
  return {
    MuiSnackbar: {
      styleOverrides: {
        root: {
          // A phone toast spans the full width and would cover the support launcher in the
          // corner; it ends where the launcher begins instead. Wider screens centre the toast
          // well clear of the corner.
          [theme.breakpoints.down('sm')]: {
            right: `calc(${theme.spacing(1)} + ${supportChatInset})`,
          },
        },
      },
    },
  }
}
